import React, { useState } from "react";
import { auth, db } from "../../firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { Box, Stack, TextField, IconButton, InputAdornment } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const SendMessage = ({ scroll }) => {
    const [message, setMessage] = useState("");

  const sendMessage = async (event) => {
    event.preventDefault();
    if (message.trim() === "") {
      alert("Enter valid message");
      return;
    }
    const { uid, displayName, photoURL } = auth.currentUser;
    await addDoc(collection(db, "messages"), {
      text: message,
      name: displayName,
      avatar: photoURL,
      createdAt: serverTimestamp(),
      uid,
    });
    setMessage("");
    scroll.current.scrollIntoView({ behavior: "smooth" });
  };
    return (

        <Box
            component="form"
            onSubmit={(event) => sendMessage(event)}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: { xs: 0, md: 'auto', lg: 'auto' },
                width: { xs: '100vw', sm: '50vw', md: '50vw', lg: '50vw' },
                p: 2,
                bgcolor: "#131313"
            }}>
            <Stack direction="row" justifyContent="space-between">
                <TextField
                    id="messageInput"
                    name="messageInput"
                    type="text"
                    variant="outlined"
                    placeholder="Type message..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    sx={{ mr: 1, bgcolor: "#343434", flex: 1 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton type="submit" sx={{ color: "#f55151" }}>
                                    <SendIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Stack>
        </Box>
    );
};

export default SendMessage;